import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";

interface Props {
  name: string;
}

const CertificationNameLabelField: React.FC<Props> = ({ name }) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.certification.nameText,
        label: name,
      }}
    />
  );
};

export default React.memo(CertificationNameLabelField);
